import { useState } from 'react';
import { galleryImages } from '../data/mock';

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const categories = ['All', 'Fashion', 'Editorial', 'Boudoir', 'Production', 'Studio'];

  const filteredImages = selectedCategory === 'All' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === selectedCategory);

  return (
    <div className="bg-black text-white min-h-screen pt-32 pb-20">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h1 className="font-display text-5xl md:text-6xl font-bold text-red-500 mb-6 uppercase">
            Gallery
          </h1>
          <p className="text-xl text-gray-300 leading-relaxed">
            Explore our cinematic environments and creative productions
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`service-button px-6 py-2 rounded-full font-mono text-xs tracking-widest uppercase transition-all ${
                selectedCategory === category
                  ? 'bg-red-600 text-white border-red-600'
                  : 'bg-transparent text-gray-400 border-red-900/50 hover:border-red-600 hover:text-red-500'
              } border`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredImages.map((image) => (
            <div 
              key={image.id}
              className="group relative overflow-hidden rounded-lg aspect-square cursor-pointer"
            >
              <img 
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span className="inline-block px-4 py-1 rounded-full bg-red-600 text-white text-xs font-mono tracking-wider uppercase">
                    {image.category}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Note */}
        <div className="max-w-3xl mx-auto mt-16 text-center">
          <p className="text-gray-500 text-sm italic">
            All images are editorial representations. Professional, discreet environments designed for striking visual content.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Gallery;